<template>
  <div v-if="picture" class="gallery-picture-pieces-overlay absolute grid grid-cols-6 grid-rows-5 inset-0">
    <div v-for="(pieceRarity, pos) in picture.pieces_positions" :key="pos">
      <div
        v-show="!picture.pieces_assembled[pos]"
        class="picture-piece"
        v-tippy="
          !canInsertThisPiece(pieceRarity)
            ? {
                theme: 'WSM',
                content: $t('gallery.noPiece'),
                placement: 'top',
              }
            : ''
        "
        @click="insertPiece(pieceRarity, pos)"
      >
        <app-main-icon class="puzzle-icon" :icon-name="`puzzle-${getRarity(pieceRarity)}`" :icon-size="56" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { mapState, mapActions } from 'pinia'
import { useGalleryPictureStore } from '@/store/pinia/gallery/pictureStore'
import type { PieceCountByRarity } from '@/interfaces/gallery/Pictures'
import { GalleryPieceRarity } from '@/interfaces/gallery/enums'
import AppMainIcon from '../GlobalComponents/AppMainIcon.vue'

export default defineComponent({
  name: 'GalleryPicturePiecesOverlay',
  components: { AppMainIcon },

  props: {
    usersPieces: {
      type: Array as PropType<PieceCountByRarity[]>,
      default: () => []
    }
  },

  computed: {
    ...mapState(useGalleryPictureStore, ['picture'])   
  },

  methods: {
    ...mapActions(useGalleryPictureStore, ['assemble']),

    getRarity(pieceRarity: GalleryPieceRarity): string {
      return (pieceRarity as string).split('_')[2]
    },

    canInsertThisPiece(rarity: GalleryPieceRarity): boolean {
      const rarityShort = rarity.split('_')[2]
      return this.usersPieces.some((pieces: PieceCountByRarity): boolean => pieces.rarity === rarityShort)
    },

    insertPiece(rarity: GalleryPieceRarity, position: number): void {
      if (this.canInsertThisPiece(rarity)) this.assemble(position)
    }
  },
})
</script>

<style lang="scss" scoped>
$imgWidth: 82rem;
$imgHeight: 40.5rem;

.gallery-picture-pieces-overlay {
  width: $imgWidth;
  height: $imgHeight;
  left: 50%;
  transform: translateX(-50%);

  .picture-piece {
    width: 100%;
    height: 100%;
    opacity: 0.95;
    box-shadow: inset 0 0 2.8125rem 0 rgba(0, 0, 0, 0.5);
    position: relative;
    cursor: pointer;

    @if $isWsm {
      background-color: #233441;
      border: solid 0.0625rem #a0dcff;
    }
    @if $isSsm {
      border: solid 0.0625rem #fff;
      background-color: #2c365c;
    }
  }

  .puzzle-icon {
    position: absolute;
    right: 0.3125rem;
    top: 0.3125rem;
  }
}
</style>
